import { render, staticRenderFns } from "./phoneCertInfo.vue?vue&type=template&id=6ccc51c4&scoped=true&"
import script from "./phoneCertInfo.vue?vue&type=script&lang=js&"
export * from "./phoneCertInfo.vue?vue&type=script&lang=js&"
import style0 from "./phoneCertInfo.vue?vue&type=style&index=0&id=6ccc51c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc51c4",
  null
  
)

export default component.exports